'use strict';

angular.module('directives.confirmClickDirective', ['mgcrea.ngStrap'])

.directive('confirmClick', ['$modal', '$rootScope', function ($modal, $rootScope) {
    return {
        link: function (scope, element, attr) {

            element.bind('click', function (event) {
                var clickAction = attr.confirmClick;

                var confirmCondition = false;
                if(angular.isDefined(attr.confirmCondition)) {
                    confirmCondition = scope.$eval(attr.confirmCondition);
                }

                if (confirmCondition) {
                    var modalScope = $rootScope.$new();

                    // Title and content come pre-translated from {{ 'key' | translate }} in attributes
                    modalScope.title = attr.confirmTitle;
                    modalScope.content = attr.confirmContent;

                    // OK button text - use translated default if not provided
                    modalScope.okButtonText = attr.confirmOkButtonText;
                    if (!modalScope.okButtonText) {
                        // For default buttons, we need to translate synchronously
                        // These will be translated in the template since we can't use {{ }} here
                        modalScope.okButtonKey = 'iam.confirmClickDirective.actions.ok';
                    }

                    // Cancel button text - use translated default if not provided
                    modalScope.cancelButtonText = attr.confirmCancelButtonText;
                    if (!modalScope.cancelButtonText) {
                        modalScope.cancelButtonKey = 'iam.confirmClickDirective.actions.cancel';
                    }

                    modalScope.okButtonColor = attr.confirmOkButtonColor || "red";

                    var confirmModal = $modal({
                        scope: modalScope,
                        show: true,
                        template: require('./confirmClick.tpl.html'),
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        confirmModal.$promise.then(confirmModal.hide);
                    }

                    modalScope.ok = function () {
                        modalScope.hideModal();
                        scope.$eval(clickAction);
                    }
                } else {
                    scope.$eval(clickAction);
                }
            });
        }
    };
}]);
